import { Config, FirebaseConfig } from './config.interface';
// Environment variables
const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST || 'localhost';
const BACKEND_PORT = process.env.REACT_APP_BACKEND_PORT || '5001';
const IS_LOCAL_DEV = process.env.REACT_APP_LOCAL_DEV === 'true';

// Create backend URL conditionally
const getBackendUrl = () => {
  if (IS_LOCAL_DEV) {
    return `https://${BACKEND_HOST}:${BACKEND_PORT}`;
  } else {
    return `https://${BACKEND_HOST}`;
  }
};

const firebaseConfig: FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Config object
export const config: Config = {
  apiEndpoint: getBackendUrl(),
  OicdAuthenticatorConfig: firebaseConfig,
  fighterMediaEndpoint:
    process.env.REACT_APP_FIGHTER_MEDIA_ENDPOINT ||
    'https://fantasy-mma-fighters-images.s3.eu-west-2.amazonaws.com',
};
